import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPhone, FiPhoneOff } from 'react-icons/fi';
import { ChatState } from '../Context/ChatProvider';
import { Avatar, Button } from '../ui';
import { useWorkspace } from './Workspace';
import ringtone from '../assets/marimba.wav';
import { t } from '../i18n';

export default function IncomingCall() {
  const { socket } = ChatState();
  const navigate = useNavigate();
  const { me, incomingCall, setIncomingCall } = useWorkspace();
  const audio = useRef(null);

  useEffect(() => {
    audio.current = new Audio(ringtone);
    audio.current.loop = true;
    audio.current.play().catch(() => {});
    // stop ringing on its own after 45s
    const t = setTimeout(() => setIncomingCall(null), 45000);
    return () => {
      clearTimeout(t);
      audio.current.pause();
      audio.current = null;
    };
  }, [setIncomingCall]);

  const accept = () => {
    const { roomId, title } = incomingCall;
    setIncomingCall(null);
    navigate(`/room/${roomId}`, { state: { title: title || t("Call") } });
  };
  const decline = () => {
    if (incomingCall.from) socket.emit('meet:decline', { roomId: incomingCall.roomId, to: incomingCall.from._id, from: { _id: me._id, fullname: me.fullname } });
    setIncomingCall(null);
  };
  const who = incomingCall.from || { fullname: incomingCall.name || t("Someone") };

  return (
    <div className="call-card" role="alertdialog" aria-label={t("Incoming call")}>
      <span className="ring"><Avatar name={who.fullname} src={who.img_user} size={48} /></span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <b>{who.fullname}</b>
        <div style={{ color: 'var(--text-subtle)', fontSize: 12 }}>{incomingCall.title ? t("invites you to “{{title}}”", { title: incomingCall.title }) : t("is calling you…")}</div>
      </div>
      <Button variant="primary" icon onClick={accept} title={t("Join")} style={{ background: 'var(--success)' }}><FiPhone /></Button>
      <Button variant="danger" icon onClick={decline} title={t("Decline")}><FiPhoneOff /></Button>
    </div>
  );
}
